
  var _styles = {
  "created-popup-card": {
    "width": "7.52rem",
    "height": "6.82667rem",
    "marginTop": "4.26667rem",
    "borderRadius": "0.48rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative"
  },
  "created-popup-subtitle": {
    "marginTop": "0.29333rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "MF YuanHei",
    "fontSize": "0.56rem",
    "textAlign": "center"
  },
  "created-popup-title": {
    "marginTop": "1.10667rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.96rem",
    "textAlign": "center"
  },
  "created-popup-description": {
    "marginTop": "0.14667rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "textAlign": "center"
  },
  "created-popup-points-label": {
    "position": "absolute",
    "top": "-0.25333rem",
    "right": 0,
    "paddingTop": 0,
    "paddingRight": "0.17333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.17333rem",
    "height": "0.50667rem",
    "borderRadius": "0.33333rem 0.33333rem 0.33333rem 0.06667rem",
    "backgroundColor": "rgb(255,45,25)",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "created-popup-points-label-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.26667rem"
  }
};



  module.exports = _styles;
  